// extracted by mini-css-extract-plugin
module.exports = {"mainImage":"MainImage_mainImage__1Jj38","header":"MainImage_header__ruQop","subHeader":"MainImage_subHeader__2Ht8t"};